import { usePocQuery } from 'core/custom-hooks/use-poc-query.hook';
import { useTranslation } from 'core/i18n/i18n';
import { settingsKeys } from 'core/query-client/keys/settings.keys';
import { showErrorNotification } from 'core/utils/notification-service';
import { useEffect } from 'react';
import { OPERATOR_TRIGGER_CATALOGUE_UNAVAILABLE_KEY } from 'modules/settings/pods/settings-operator-custom-notifications/service/operator-trigger-catalogue.constants';
import { DeviceTypeTriggerCatalogue } from 'modules/settings/pods/settings-operator-custom-notifications/operator-custom-notification.vm';
import { searchRegisteredEvents } from 'modules/settings/pods/settings-operator-custom-notifications/service/operator-trigger-catalogue.service';

const EMPTY_CATALOGUE: DeviceTypeTriggerCatalogue[] = [];

export const useOperatorTriggerCatalogue = (deviceTypeIds: string[]) => {
    const { t } = useTranslation();

    const { data, isFetching, isError } = usePocQuery<DeviceTypeTriggerCatalogue[]>({
        queryKey: settingsKeys.operatorTriggerCatalogue(deviceTypeIds),
        queryFn: () => searchRegisteredEvents(deviceTypeIds),
        enabled: deviceTypeIds.length > 0,
        placeholderData: (previousCatalogue?: DeviceTypeTriggerCatalogue[]) =>
            deviceTypeIds.length > 0 ? previousCatalogue : undefined,
    });

    useEffect(() => {
        if (isError) {
            showErrorNotification(t(OPERATOR_TRIGGER_CATALOGUE_UNAVAILABLE_KEY));
        }
    }, [isError, t]);

    return {
        catalogue: data ?? EMPTY_CATALOGUE,
        isLoadingCatalogue: isFetching,
        hasFailedToLoadCatalogue: isError,
    };
};
